<template>
  <main class="content">
      <div class="row">
          <h1>
              Notifications
          </h1>
      </div>
      <form novalidate v-on:submit.prevent="broadcastNotification" class="form">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>
          <Message v-if="successMessage" :message-content="successMessage" message-status="success"></Message>

          <fieldset class="form--item">
              <label class="label" for="">
                  Title
              </label>
              <div class="input_text" id="title">
                  <input name="" required v-model="notification.title" placeholder="Please enter notification title" type="text" value=""/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Message
              </label>
              <div class="input_text input_text_long" id="message">
                  <textarea name="" required v-model="notification.message" placeholder="Please enter notification message" type="text" value="">
                  </textarea>
              </div>
          </fieldset>
          <div class="row">
              <button class="btn btn_blue" type="submit">
                  Send notifications
              </button>
          </div>
      </form>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import Message from '../Message.vue'
import Loading from '../Loading.vue'

import * as ValidateForm from '../../mixins/validate-form.mixin';
import * as CreateResource from '../../mixins/createResource.mixin';

export default {
  name: 'Notifications',
  components: {Message, Loading},
  mixins:[ValidateForm, CreateResource],
  data () {
    return {
      notification: {},
      resource: 'notifications/broadcast',
      parentResource: 'Notifications',
      successMessage: '',
      required_fields: [
        {'attribute': 'notification.title', 'message': 'Title is missing', 'id': 'title'},
        {'attribute': 'notification.message', 'message': 'Message is missing', 'id': 'message'}
      ]
    }
  },
  methods: {
    broadcastNotification(){
      var self = this;
      
      if(!self.validate()){
        return false;
      }

      HttpService.post(self.resource, self.notification, function(response, error){
        if(error){
          //Handle error
          self.errorMessage = error.message;
        }else{
          self.successMessage = 'Successfully broadcasted notification';
          self.notification = {};
        }
        self.loadingVisible = false;
      });
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Notifications.vue?30312893